import React, { useState } from 'react';
import { LogOut, MessageSquare, Users, FileText, Briefcase } from 'lucide-react';
import ReviewsManagement from './ReviewsManagement';
import JobApplicationsManagement from './JobApplicationsManagement';
import PositionsManagement from './PositionsManagement';

const AdminDashboard = ({ user, onLogout }) => {
  const [activeTab, setActiveTab] = useState('reviews');
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleLogout = async () => {
    setIsLoggingOut(true);
    try {
      const formData = new FormData();
      formData.append('action', 'logout');
      
      await fetch('/backend/api/admin-auth.php', {
        method: 'POST',
        credentials: 'include',
        body: formData
      });
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      setIsLoggingOut(false);
      onLogout();
    }
  };

  const tabs = [
    { id: 'reviews', name: 'Recenzije', icon: MessageSquare },
    { id: 'applications', name: 'Prijave', icon: FileText },
    { id: 'positions', name: 'Pozicije', icon: Briefcase },
  ];

  const renderContent = () => {
    switch (activeTab) {
      case 'reviews':
        return <ReviewsManagement />;
      case 'applications':
        return <JobApplicationsManagement />;
      case 'positions':
        return <PositionsManagement />;
      default:
        return null;
    }
  };

  return (
    <div className="p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="text-3xl font-bold text-foreground">Admin Panel</h1>
            <p className="text-muted-foreground mt-1">
              Upravljajte sadržajem i korisnicima
              {user && <span className="ml-2">• Prijavljen: <strong>{user.username}</strong></span>}
            </p>
          </div>
          <button
            onClick={handleLogout}
            disabled={isLoggingOut}
            className="flex items-center gap-2 px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded-lg transition-colors disabled:opacity-50"
          >
            <LogOut className="w-4 h-4" />
            {isLoggingOut ? 'Odjavljivanje...' : 'Odjavite se'}
          </button>
        </div>

        {/* Tabs */}
        <div className="border-b border-border mb-8">
          <nav className="flex space-x-8">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`flex items-center gap-2 py-4 px-1 border-b-2 font-medium transition-colors ${
                    activeTab === tab.id
                      ? 'border-primary text-primary'
                      : 'border-transparent text-muted-foreground hover:text-foreground'
                  }`}
                >
                  <Icon className="w-5 h-5" />
                  {tab.name}
                </button>
              );
            })}
          </nav>
        </div>

        {/* Content */}
        <div className="bg-card border border-border rounded-xl p-6">
          {renderContent()}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;